<app-loader></app-loader>
<router-outlet>
  <app-cookie-consent></app-cookie-consent>
</router-outlet>

